import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, Renderer2, inject, output, signal } from '@angular/core';
import { MyOverlayRef } from 'src/app/core/services/overlay/myoverlay-ref';

export interface ModalOverlayData {
  id: string;
  headerText: string;
  bodyText: string;
  closeIcon: string;
  modalStyle: string;
  parentElementRef: ElementRef;
}

@Component({
  standalone: true,
  selector: 'app-configure-overlay',
  templateUrl: './configure-overlay.component.html',
  styleUrls: ['./configure-overlay.component.scss'],
  imports: [CommonModule]
})
export class ConfigureOverlayComponent implements OnInit {
  myOverlayRef = inject(MyOverlayRef);
  private renderer = inject(Renderer2);

  overlayData = signal<Partial<ModalOverlayData> | null>(null);

  sectionClicked$ = output<any>();

  onSectionClicked(event: any) {
    this.sectionClicked$.emit(event);
  }

  ngOnInit(): void {
    this.overlayData.set(this.myOverlayRef?.data);

    const modalStyle = this.overlayData()?.modalStyle;

    if (modalStyle?.length) {
      const style = this.renderer.createElement('style');
      style.id = 'style-modal-' + this.overlayData()?.id;
      const text = this.renderer.createText(modalStyle || "");
      this.renderer.appendChild(style, text);
      this.renderer.appendChild(this.overlayData()?.parentElementRef?.nativeElement, style);
    }
  }
}

